import { useEffect } from "react";
import favicon from "./assets/favicon.ico";
export default function useEntertainmentBrand() {
  useEffect(() => {
    const existing = document.querySelector('link[rel="icon"]');
    const icon = existing || document.createElement("link"), previous = icon.getAttribute("href");
    icon.rel = "icon"; icon.href = favicon;
    if (!existing) document.head.appendChild(icon);
    return () => { if (!existing) icon.remove(); else if (previous === null) icon.removeAttribute("href"); else icon.setAttribute("href", previous); };
  }, []);
}
